import ChargePointMap from '@/app/routes/ChargeCenter/ChargePointMap';
import { chargeCenterMonitorLayoutRoute } from '@/modules/charge-center/layout/route';
import { createRoute } from '@tanstack/react-router';

export const mapRoute = createRoute({
  getParentRoute: () => chargeCenterMonitorLayoutRoute,
  path: 'map',
  component: ChargePointMap,
});
